import type { AddButton } from './../ricos-types';
import { INSERT_PLUGIN_BUTTONS, TOOLBARS } from './../editor-common';

import { INSERT_EMOJI_BUTTON } from './data-hooks';
import EmojiPluginIcon from './icons/EmojiPluginIcon';
import EmojiInsertModal from './modals/InsertModal';
import { EMOJI_TYPE, emojiModals } from './types';

export const toolbarsToAddIn: (TOOLBARS.MOBILE | TOOLBARS.FOOTER | TOOLBARS.SIDE)[] = [
  TOOLBARS.FOOTER,
  TOOLBARS.SIDE,
  TOOLBARS.MOBILE,
];

export const getAddButtons = (_config: $TSFixMe, services: $TSFixMe): AddButton[] => {
  const {
    modals,
    context: { isMobile = false },
  } = services || {};

  return isMobile
    ? []
    : [
        {
          id: EMOJI_TYPE,
          label: INSERT_PLUGIN_BUTTONS.EMOJI,
          dataHook: INSERT_EMOJI_BUTTON,
          icon: EmojiPluginIcon,
          tooltip: 'EmojiPlugin_InsertButton_Tooltip',
          toolbars: toolbarsToAddIn,
          command: ({ referenceElement }) => {
            modals?.togglePluginPanel({
              id: emojiModals.insert,
              Component: EmojiInsertModal,
              componentProps: {},
              isMobile: false,
              positioning: {
                referenceElement,
                placement: 'bottom',
              },
            });
            return true;
          },
          menuConfig: {
            tags: 'Emoji_plugin_search_tags',
          },
        },
      ];
};
